/**
 * Dashboard Layout for Desktop Web
 * Combines persistent sidebar, header, and main content area
 */
import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import Sidebar from '../navigation/Sidebar';
import Header from '../navigation/Header';
import { DesktopTheme } from '../theme/desktopTheme';
import { useDesktopDetect } from '../hooks/useDesktopDetect';

const DashboardLayout = ({
  children,
  currentRoute,
  quarterSelector,
  showHeader = true,
}) => {
  const { isDesktopWeb, shouldShowSidebar, shouldCollapseSidebar } =
    useDesktopDetect();

  // Only apply desktop layout on web with sufficient width
  if (!isDesktopWeb) {
    return <>{children}</>;
  }

  return (
    <View style={styles.container}>
      {/* Persistent Sidebar */}
      {shouldShowSidebar && (
        <Sidebar
          isCollapsed={shouldCollapseSidebar}
          currentRoute={currentRoute}
        />
      )}

      {/* Main Content Area */}
      <View style={styles.mainArea}>
        {/* Header */}
        {showHeader && (
          <Header currentRoute={currentRoute} quarterSelector={quarterSelector} />
        )}

        {/* Content */}
        <View style={styles.content}>{children}</View>
      </View>
    </View>
  );
};

const { colors, layout } = DesktopTheme;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: colors.contentBg,
    ...(Platform.OS === 'web' && {
      height: '100vh',
      overflow: 'hidden',
    }),
  },
  mainArea: {
    flex: 1,
    flexDirection: 'column',
    backgroundColor: colors.contentBg,
    ...(Platform.OS === 'web' && {
      height: '100vh',
      overflow: 'hidden',
    }),
  },
  content: {
    flex: 1,
    backgroundColor: colors.contentBg,
    ...(Platform.OS === 'web' && {
      overflow: 'auto',
    }),
  },
});

export default DashboardLayout;
